import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CloseAccountInformationComponent } from './information/information.component';
import { CloseAccountRequestComponent } from './request/request.component';
import { CloseAccountStatusComponent } from './status/status.component';
import { MatAutocompleteModule, MatRadioModule, MatSelectModule } from '@angular/material';
import { NgxMaskModule } from 'ngx-mask';
import { CloseAccountTermsComponent } from './terms/terms.component';
import { CloseAccountService } from './close-account.service';

@NgModule({
imports: [
	CommonModule,
	CurrencyMaskModule,
	SharedModule,
	RouterModule,
	MatCardModule,
	MatTableModule,
	MatCheckboxModule,
	FormsModule,
	ReactiveFormsModule,
	CommonModule,
	CurrencyMaskModule,
	SharedModule,
	RouterModule,
	MatCardModule,
	MatTableModule,
	MatCheckboxModule,
	MatRadioModule,
	FormsModule,
	ReactiveFormsModule,
	NgxMaskModule.forRoot(),
	MatSelectModule,
	MatAutocompleteModule,
],
declarations: [
	CloseAccountInformationComponent,
	CloseAccountRequestComponent,
	CloseAccountStatusComponent,
	CloseAccountTermsComponent,
],
providers: [
	CloseAccountService
],
entryComponents: [],
})
export class CloseAccountModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/close-account/close-account.module.ts